import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import SettingRemoveModal from './SettingRemoveModal'

export default class RemoveServiceLevelModal extends React.Component<RouteComponentProps<any>> {
  public render() {
    return (
      <SettingRemoveModal
        setting={{ label: 'Door to door', id: 1 }}
        settingType='Service Level'
        onRemove={this.onRemove}
        onClose={this.onClose}
      />
    )
  }

  private onRemove = () => {
    console.log('remove')
  }

  private onClose = () => {
    this.props.history.push('/global-settings/service-level')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/RemoveServiceLevelModal.tsx